import React from "react";
import { ListItem, ListItemText } from "@mui/material";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import CustomIcon from "../../CustomIcon/CustomIcon";
import * as Styles from "../InfoListCard.styles";

interface InfoListType {
  label: string;
  value: string;
}

interface InfoListCardSubSectionPropsType {
  subSectionTitle: string;
  subSectionIcon?: React.ReactNode;
  subSectionItems: InfoListType[];
}

export default function InfoListCardSubSection({ subSectionTitle, subSectionIcon, subSectionItems }: InfoListCardSubSectionPropsType) {
  return (
    <>
      <ListItem disablePadding>
        <Styles.CustomListItemIcon>
          {subSectionIcon ?? <CustomIcon Icon={BusinessRoundedIcon} size={"var(--icon-size-lg)"} />}
        </Styles.CustomListItemIcon>
        <Styles.CustomListItemText primary={subSectionTitle} bold={true} />
      </ListItem>

      {subSectionItems.map((item, index) => (
        <ListItem disablePadding key={index}>
          <ListItemText
            disableTypography
            secondary={
              <Styles.CustomItemTextContent>
                <strong>{item.label}: </strong>
                {item.value}
              </Styles.CustomItemTextContent>
            }
          />
        </ListItem>
      ))}
    </>
  );
}
